import { defineStore } from "pinia"

export const useNavigationStore = defineStore("navigation", {
  state: () => ({
    mainMenuOpen: true,
    userMenuOpen: false,
    currentAppId: "iea" as string | null,
    currentService: null as string | null,
    apps: [
      // TODO: replace with appIds from listApp query
      {
        id: "all",
        name: "All Apps",
        description: "A view of all apps merged together",
        logo: "/logo/apex.png",
        status: "active",
      },
      {
        id: "iea",
        name: "website",
        description: "Main website of the Paris Institute for Advanced Study",
        logo: "/logo/iea.png",
        status: "active",
      },
    ] as Array<{
      id: string
      name: string
      description: string
      logo: string
      status: string
    }>,
  }),
  actions: {
    toggleMainMenu() {
      this.mainMenuOpen = !this.mainMenuOpen
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen
    },
    setCurrentAppId(appId: string | null) {
      this.currentAppId = appId
    },
    setCurrentService(service: string | null) {
      this.currentService = service
    },
  },
})
